import programs from './en-US/programs.json';
import translation from './en-US/translation.json';
import auth from './en-US/auth.json';
import circles from './en-US/circles.json';
import dashboard from './en-US/dashboard.json';
import user from './en-US/user.json';
import validation from './en-US/validation.json';
import providers from './en-US/providers.json';
import shared from './en-US/shared.json';
import goals from './en-US/goals.json';
import onboarding from './en-US/onboarding.json';
import videoSessions from './en-US/videoSessions.json';
import admin from './en-US/admin.json';
import assessments from './en-US/assessments.json';
import intakeForms from './en-US/intakeForms.json';
import dailyPause from './en-US/dailyPause.json';
import insuranceForm from './en-US/insuranceForm.json';
import courses from './en-US/courses.json';
import payments from './en-US/payments.json';
import dependents from './en-US/dependents.json';
import benefits from './en-US/benefits.json';
import care from './en-US/care.json';
import messaging from './en-US/messaging.json';
import careNavigation from './en-US/careNavigation.json';
import vita from './en-US/vita.json';

export const enUS = {
    programs,
    translation,
    auth,
    circles,
    dashboard,
    user,
    validation,
    providers,
    shared,
    goals,
    onboarding,
    videoSessions,
    admin,
    assessments,
    intakeForms,
    dailyPause,
    insuranceForm,
    courses,
    payments,
    dependents,
    benefits,
    care,
    messaging,
    careNavigation,
    vita,
};
